import { render, staticRenderFns } from "./helpDesks.vue?vue&type=template&id=f4a08f5c&"
import script from "./helpDesks.vue?vue&type=script&lang=js&"
export * from "./helpDesks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports